import React from 'react';
import { Container } from '@mui/material';
import { LegalInfoContainer, LegalInfoText, SectionPaper } from './LegalInfo.styles';
interface Section {
  title: string;
  content: string;
}
interface LegalInfoProps {
  title: string;
  sections: Section[];
  lastUpdated?: string;
}
const LegalInfo = ({ title, sections, lastUpdated }: LegalInfoProps) => {
  return (
    <Container maxWidth="xl">
      <LegalInfoContainer>
        <LegalInfoText variant="h1">{title}</LegalInfoText>
        {lastUpdated && (
          <LegalInfoText variant="body2">
            Last updated: {lastUpdated}
          </LegalInfoText>
        )}
        {sections.map((section, index) => (
          <SectionPaper key={index} elevation={0}>
            <LegalInfoText variant="h2">
              {section.title}
            </LegalInfoText>
            <LegalInfoText variant="body1">{section.content}</LegalInfoText>
          </SectionPaper>
        ))}
      </LegalInfoContainer>
    </Container>
  );
};
export default LegalInfo;
